import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import { TranslateContext } from '@shared/pipes/translate.pipe';
import { Utilities } from '@shared/utilities/utilities.model';

@Component({
	selector: 'amd-drag-and-drop-file',
	templateUrl: './drag-and-drop-file.component.html',
	styleUrls: ['./drag-and-drop-file.component.scss']
})
export class DragAndDropFileComponent implements OnInit {
	@ViewChild('error_extension_one_file') errorExtensionOneFile: ElementRef;

	@Output() filesChangeEmitter: EventEmitter<File[]> = new EventEmitter();
	@Input() allowed_extensions: Array<string> = [];
	@Input() limit: number;
	@Input() descFile: string;
	@Input() disabled: boolean;
	@Input() multiple: boolean = false;
	activeColor: string = '#19becf';
	baseColor: string = '#ccc';
	overlayColor: string = 'rgba(255,255,255,0.5)';

	dragging: boolean = false;
	translateContext = TranslateContext;

	constructor(public snackBar: MatSnackBar) {
		if(Utilities.isEmpty(this.multiple)) this.multiple = false;
	}

	ngOnInit(): void {
	}

	handleDragEnter(): void {
		this.dragging = true;
	}

	handleDragLeave(): void {
		this.dragging = false;
	}

	handleDrop(event: any): boolean {
		if (event instanceof Event) {
			event.preventDefault();
		}
		this.dragging = false;
		return this.handleInputChange(event);

	}

	handleInputChange(event: any): boolean {
		if (event) {
			if (event instanceof Event) {
				event.stopPropagation();
			}
			const files: any = (event.dataTransfer ? event.dataTransfer.files : event.target.files);
			if (files.length > 0 && files.length <= this.limit) {
				let allAdded: boolean = true;
				const fls: File[] = [];
				for (let i: number = 0; i < files.length; i++) {
					const file: any = files[i];
					const dotPosition: number = file.name.lastIndexOf('.');
					if (dotPosition >= 0 && dotPosition < file.name.length && this.allowed_extensions.includes(file.name.substr(dotPosition).toLowerCase())) {
						fls.push(file);
					} else {
						allAdded = false;
					}
				}
				if (fls.length > 0) {
					this.filesChangeEmitter.emit(fls);
					return true;
				}
				if (!allAdded) {
					const config: MatSnackBarConfig = new MatSnackBarConfig();
					config.duration = 10000;
					config.panelClass = ['snack-bar-info'];
					const message: string = this.errorExtensionOneFile.nativeElement.innerHTML + this.allowed_extensions.toString();
					this.snackBar.open(message, null, config);
				}
			}
		}
		this.filesChangeEmitter.emit(null);
		return false;
	}
}